import { render, staticRenderFns } from "./singleTeamOrMember.vue?vue&type=template&id=4a2433b9&scoped=true&"
import script from "./singleTeamOrMember.vue?vue&type=script&lang=js&"
export * from "./singleTeamOrMember.vue?vue&type=script&lang=js&"
import style0 from "./singleTeamOrMember.vue?vue&type=style&index=0&id=4a2433b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2433b9",
  null
  
)

export default component.exports